import { render, staticRenderFns } from "./Clasification.vue?vue&type=template&id=6f91ff7e&scoped=true"
import script from "./Clasification.vue?vue&type=script&lang=js"
export * from "./Clasification.vue?vue&type=script&lang=js"
import style0 from "./Clasification.vue?vue&type=style&index=0&id=6f91ff7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f91ff7e",
  null
  
)

export default component.exports